import Vue from 'vue';
import HttpUtil from '../../lib/httpUtil';
import { getApiUrl } from '../../lib/apiUtil';
import { getCurrentParams, goNewHTML } from '../../lib/routerUtil';
import Toast from '../../components/Toast.vue';
import ModelName from '../../components/ModelName.vue';
import Slider from '../../components/Slider.vue';
import FooterName from '../../components/Footer.vue';

import './style.scss';

// require('../../lib/bannerTop.js');
require('../../lib/bannerPic.js');

// require('vconsole');

const currentParams = getCurrentParams();
new Vue({
  el: '#app',
  data() {
    return {
      uid: currentParams.uid,
      token: currentParams.token,
      titleicon: require('../../static/images/bei.png'),
      locaBaidu: require('../../static/images/logo.png'),
      locaBaidu1: require('../../static/images/logo1.png'),
      banner1: require('../../static/images/banner1.jpg'),
      banner2: require('../../static/images/banner2.jpg'),
      banner3: require('../../static/images/banner3.jpg'),
      challenge1: require('../../static/images/home_p1.jpg'),
      challenge2: require('../../static/images/home_p2.jpg'),
      challenge3: require('../../static/images/home_p3.jpg'),
      challenge4: require('../../static/images/home_p4.jpg'),
      challenge5: require('../../static/images/home_p5.jpg'),
      challenge6: require('../../static/images/home_p6.jpg'),
      challenge7: require('../../static/images/home_p7.jpg'),
      call: require('../../static/images/call.png'),
      zhaopin: require('../../static/images/zhaopin.png'),
      process1: require('../../static/images/process1.jpg'),
      process2: require('../../static/images/process2.jpg'),
      process3: require('../../static/images/process3.jpg'),
      process4: require('../../static/images/process4.jpg'),
      kehu1: require('../../static/images/kehu1.jpg'),
      kehu2: require('../../static/images/kehu2.jpg'),
      kehu3: require('../../static/images/kehu3.jpg'),
      kehu4: require('../../static/images/kehu4.jpg'),
      erweima: require('../../static/images/erweima.png'),
      infoData: {},
      noFixed: true,
    };
  },
  mounted() {
    // if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    //   window.location.href = 'http://wap.zanhr.com/';
    // }
    // this.getQuestionlist();
    this.$refs.rfsd.addEventListener('scroll', (ev) => {
      if (ev.target.scrollTop > 200) {
        this.noFixed = false;
      } else {
        this.noFixed = true;
      }
    });
  },
  methods: {
    /*
    *  获取列表
    * */
    getQuestionlist() {
      HttpUtil.send({
        method: 'get',
        url: getApiUrl('/official/getCountInfo'),
        query: {}
      }).then((data) => {
        if (data.code !== 0) {
          return;
        }
        this.infoData = data.data;
      }).catch((error) => {
        this.showTip(error.msg || '获取问答信息失败。');
      });
    },
    goBackstage(indexx) {
      goNewHTML('backstage', { shouIndex: indexx });
    },
    goMarketing(indexx) {
      goNewHTML('marketing', { shouIndex: indexx });
    },
    goService(indexx) {
      goNewHTML('service', { shouIndex: indexx });
    },
    goAboutUs(indexx) {
      goNewHTML('aboutUs', { shouIndex: indexx });
    },
    goMicroShop() {
      goNewHTML('microShop');
    },
    goCityPartner() {
      goNewHTML('cityPartner');
    },
    goEffect() {
      goNewHTML('effect');
    },
    goZanhr() {
      window.location.href = 'http://e.zanhr.com';
    },
    /*
    *  电话咨询弹窗调用
    * */
    openModelName() {
      this.$refs.modelName.showModalName();
    },
    setObject(reqData) {
      if (!reqData.name) {
        this.showTip('请输入姓名');
        return;
      }
      if (!/^1[345789]\d{9}$/.test(reqData.mobile)) {
        this.showTip('请输入合法的手机号');
        return;
      }
      HttpUtil.send({
        method: 'post',
        url: getApiUrl('/official/saveConsult'),
        data: {
          name: reqData.name,
          mobile: reqData.mobile
        }
      }).then((data) => {
        if (data.code !== 0) {
          this.showTip(data.msg || '提交失败,请稍后重试');
          return;
        }
        this.showTip('已经为您预约成功，我们的商务人员将在1小时内联系您！');
        this.$refs.modelName.closeModel();
      }).catch((error) => {
        this.showTip(error.msg || '提交失败,请稍后重试');
      });
    },
    // 请求之后提示
    showTip(msg) {
      this.$refs.toast.openModel({
        tip: msg || '请求失败，请稍后重试',
        position: 'bottom',
        expires: 3000,
      });
    }
  },
  components: {
    Toast,
    Slider,
    ModelName,
    FooterName,
  }
});
// Vue.config.productionTip = false;



// WEBPACK FOOTER //
// ./src/views/index/index.js